export default "__VITE_ASSET__e5558573__"